import { render, staticRenderFns } from "./QuaImage.vue?vue&type=template&id=075276d6&scoped=true&"
import script from "./QuaImage.vue?vue&type=script&lang=js&"
export * from "./QuaImage.vue?vue&type=script&lang=js&"
import style0 from "./QuaImage.vue?vue&type=style&index=0&id=075276d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075276d6",
  null
  
)

export default component.exports